import React from "react";

interface ArchitectureSectionProps {
  id?: string;
  eyebrow: React.ReactNode;
  heading: React.ReactNode;
  intro: React.ReactNode;
  sources: string[];
  foot: React.ReactNode;
}

const ArchitectureSection: React.FC<ArchitectureSectionProps> = ({
  id,
  eyebrow,
  heading,
  intro,
  sources,
  foot,
}) => {
  return (
    <section id={id} className="cs-section cs-architecture">
      <div className="cs-arch-inner">
        <div className="cs-arch-head">
          <div>
            <div className="eyebrow">{eyebrow}</div>
            <h2>{heading}</h2>
          </div>
          <p>{intro}</p>
        </div>

        <div className="cs-schematic">
          <div className="cs-schematic-row">
            <div className="sch-node sch-source">
              <div className="sch-label">Source connectors</div>
              <div className="sch-items">
                {sources.map((s) => <span key={s}>{s}</span>)}
              </div>
            </div>

            <div className="sch-arrow">→</div>

            <div className="sch-node sch-bronze">
              <div className="sch-label">Bronze</div>
              <div className="sch-desc">Raw ingested data</div>
            </div>

            <div className="sch-arrow">→</div>

            <div className="sch-node sch-specs">
              <div className="sch-label">Specs</div>
              <div className="sch-desc">Versioned SQL</div>
            </div>

            <div className="sch-arrow">→</div>

            <div className="sch-node sch-gold">
              <div className="sch-label">Gold</div>
              <div className="sch-desc">Typed business objects</div>
            </div>

            <div className="sch-arrow">→</div>

            <div className="sch-node sch-kpi">
              <div className="sch-label">KPIs</div>
              <div className="sch-desc">Named metrics</div>
            </div>

            <div className="sch-arrow sch-arrow-fork">⤳</div>

            <div className="sch-output-stack">
              <div className="sch-node sch-output">
                <div className="sch-label">Dashboards</div>
              </div>
              <div className="sch-node sch-output sch-output-accent">
                <div className="sch-label">Workflows</div>
              </div>
            </div>
          </div>

          <div className="cs-schematic-foot">{foot}</div>
        </div>
      </div>
    </section>
  );
};

export default ArchitectureSection;
